import {getMethod, postMethod} from '~/api'

async function get(queryParams) {
    const url = `/api/hotel-room-amenities?productId=${queryParams.productId}&roomId=${queryParams.roomId}&locale=${queryParams.locale || 'all'}`
    return await getMethod(url)
}

async function post(queryParams, amenitiesData) {
    const url = `/api/hotel-room-amenities?productId=${queryParams.productId}&hotelId=${queryParams.hotelId}&roomId=${queryParams.roomId}`
    return await postMethod(url, amenitiesData)
}

export {get, post}
